import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
// import ListOperations from './ListOperations'
import EditOperationForm from './EditOperationForm'
import List1 from './List1'
import List2 from './List2'
import List3 from './List3'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { useLocation, useNavigate } from 'react-router-dom'
export const MonParcoursPro = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const location = useLocation()
  const navigate = useNavigate()
  // const [operations, setOperations] = useState({})
  const [operationsL1, setOperationsL1] = useState({})
  const [operationsL2, setOperationsL2] = useState({})
  const [operationsL3, setOperationsL3] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedRows3, setSelectedRows3] = useState([])

  const [selected, setSelected] = useState(false)
  const [openExperienceFromUrl, setOpenExperienceFromUrl] = useState(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const urlAction = searchParams.get('action') || searchParams.get('modal')

    if (urlAction === 'new-experience') {
      setOpenExperienceFromUrl(true)
    }
  }, [location.search])

  const fetchdata = () => {
    fetchList1()
    fetchList2()
    fetchList3()
  }

  useEffect(() => {
    fetchdata()
  }, [])
  // const updateOperation = ()=>{
  //   fetchdata()
  // }
  const fetchList1 = async (pagination = '') => {
    let url = `${urls.crudParcoursProOperations}?ParcoursType=Expérience&limit=100`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperationsL1({ ...response.data })
    }
  }
  const fetchList2 = async (pagination = '') => {
    let url = `${urls.crudParcoursProOperations}?ParcoursType=Formation&limit=100`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperationsL2({ ...response.data })
    }
  }
  const fetchList3 = async (pagination = '') => {
    let url = `/api/Professional/userCompetence/?limit=100000`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperationsL3({ count: response.data.length, results: response.data })
    }
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('parcoursPro.alertSelectOne')) // LAP-733 (GE022)
    } else {
      const response = await makePostRequest(
        urls.deleteBulkParcoursOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        fetchdata()
      }
    }
  }

  return (
    <>
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          {isMobile ? (
            <Box display={'flex'} gap={2} color={'white'}>
              <CreateOperationForm
                fetchdata={fetchdata}
                openFromUrl={openExperienceFromUrl}
                defaultParcoursType="Expérience"
                onUrlOpenConsumed={() => {
                  setOpenExperienceFromUrl(false)
                  navigate(location.pathname, { replace: true })
                }}
              />
              <RemoveCircleIcon onClick={deleteBulkOperations} />
              <EditIcon
                onClick={() => {
                  if (selectedRows.length === 1) {
                    // console.log(operationsL1)
                    // console.log(operationsL2)
                    let obj = {}

                    operationsL1?.results.forEach((e) => {
                      if (e.id === selectedRows[0]) {
                        obj = e
                      }
                    })
                    operationsL2?.results.forEach((e) => {
                      if (e.id === selectedRows[0]) {
                        obj = e
                      }
                    })
                    setSelectedRowsParams(obj)
                    setSelected(true)
                  } else {
                    setSelected(false)
                    alert(t('parcoursPro.alertSelectOneToEdit')) // LAP-733 (GE022)
                  }
                }}
              />
            </Box>
          ) : (
            <Box>
              <CreateOperationForm
                fetchdata={fetchdata}
                openFromUrl={openExperienceFromUrl}
                defaultParcoursType="Expérience"
                onUrlOpenConsumed={() => {
                  setOpenExperienceFromUrl(false)
                  navigate(location.pathname, { replace: true })
                }}
              />
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    // console.log(operationsL1)
                    // console.log(operationsL2)
                    let obj = {}

                    operationsL1?.results.forEach((e) => {
                      if (e.id === selectedRows[0]) {
                        obj = e
                      }
                    })
                    operationsL2?.results.forEach((e) => {
                      if (e.id === selectedRows[0]) {
                        obj = e
                      }
                    })
                    setSelectedRowsParams(obj)
                    setSelected(true)
                  } else {
                    setSelected(false)
                    alert(t('parcoursPro.alertSelectOneToEdit')) // LAP-733 (GE022)
                  }
                }}
              >
                {t('parcoursPro.btnEdit') /* LAP-733 (GE022) */}
              </CustomButton>

              {/* supprimer */}
              <CustomButton onClick={deleteBulkOperations}>{t('parcoursPro.btnDelete') /* LAP-733 (GE022) */}</CustomButton>
            </Box>
          )}
        </Box>
        <Box
          display="flex"
          // justifyContent="space-evenly"
          flexDirection={isMobile ? 'column' : 'row'}
          gap={2}
          pb={3}
        >
          <Box width={'100%'}>
            <List1 setSelectedRows={setSelectedRows} operations={operationsL1} />
          </Box>
          <Box width={'100%'}>
            <List2 setSelectedRows={setSelectedRows} operations={operationsL2} />
          </Box>
          <Box width={'100%'}>
            <List3 setSelectedRows={setSelectedRows3} operations={operationsL3} />
          </Box>
        </Box>
      </Container>
      {selected ? (
        <EditOperationForm
          setSelected={setSelected}
          params={selectedRowsParams}
          updateOperation={fetchdata}
        />
      ) : (
        ''
      )}
    </>
  )
}
